import {
  getRawContentFromCallToAction,
} from '@msd-npm-gmc-dev/gmc-dc-assembler-draftjs2lexical';
import { cloneDeep } from 'lodash';
import * as Models from 'models';
import { isImmutable } from 'utils/immutable';
import { convertRawContent2LexicalState, ConverterType } from './RawContentConverter';

const cache = new Map();

export function confirmLexicalStateInCTAComponent(
  ctaComponent: Models.CallToAction,
  relation: Models.CallToActionStyles | undefined,
  projectType: string,
  fonts?: Models.BrandFontsList,
): Models.CallToAction;
export function confirmLexicalStateInCTAComponent(
  ctaComponent: Models.CallToActionMap,
  relation: Models.CallToActionStyles | undefined,
  projectType: string,
  fonts?: Models.BrandFontsList,
): Models.CallToActionMap;
export function confirmLexicalStateInCTAComponent(
  ctaComponent: Models.CallToActionMap | Models.CallToAction,
  relation: Models.CallToActionStyles | undefined,
  projectType: string,
  fonts?: Models.BrandFontsList,
): Models.CallToActionMap | Models.CallToAction {
  const isImmutableMap = isImmutable(ctaComponent);
  let lexicalState = isImmutableMap ? ctaComponent.get('lexicalState') : ctaComponent.lexicalState;
  if (lexicalState) {
    return ctaComponent;
  }

  const componentKey = JSON.stringify(isImmutableMap ? ctaComponent.toJSON() : ctaComponent);
  const relationsKey = JSON.stringify(relation);
  const cacheKey = `${String(isImmutableMap)}_${projectType}_${componentKey}_${relationsKey}`;
  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }

  const rawContent = getRawContentFromCallToAction(ctaComponent, relation, projectType, fonts);
  if (rawContent) {
    const editorState = convertRawContent2LexicalState({ rawContent, type: ConverterType.CTA, fonts });
    lexicalState = JSON.stringify(editorState);
  } else {
    lexicalState = null;
  }

  if (isImmutableMap) {
    const updatedComponent = ctaComponent.set('lexicalState', lexicalState);
    cache.set(cacheKey, updatedComponent);

    return updatedComponent;
  }

  const updatedComponent = cloneDeep(ctaComponent);
  updatedComponent.lexicalState = lexicalState;
  cache.set(cacheKey, updatedComponent);

  return updatedComponent;
}
